import React, { useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

export interface IVHSStatProps extends IBaseElementProps {
	count?: number;
	showCommas?: boolean;
	prefix?: string;
	suffix?: string;
	textClassName?: string;
	/**
	 * @control textarea
	 */
	statText?: string;
}

/**
 * Stats
 * @block
 * @icon editor-ol-rtl
 */
const VHSStat: React.FC<IVHSStatProps> = ({
	count,
	showCommas = true,
	prefix,
	suffix,
	statText,
	textClassName,
	className,
	classNames = [],
}) => {
	const ref = useRef(null);

	let numberWithSpaces = function (x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	};

	return (
		<div className={className || cn('stat', ...classNames)}>
			<span>
				{prefix && <span className="stat-count__prefix">{prefix}</span>}
				{count && (
					<span className="stat-count__number" ref={ref}>
						{numberWithSpaces(count)}
					</span>
				)}
				{suffix && <span className="stat-count__suffix">{suffix}</span>}
			</span>
			<span className={textClassName || 'stat-text'}>{statText}</span>
		</div>
	);
};

export default VHSStat;
